export default "__VITE_ASSET__8sh40a5o__"